<script>
import AppMap from "./AppMap.vue";
export default {
  name: "AboutUs",
  components: { AppMap },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
<template>
  <div class="wrapper">
    <h3>Контакты</h3>
    <div class="wrap">
      <div class="info">
        <div class="group">
          <span class="item-group main">Адрес:</span>
          <span class="item-group"
            >г Оренбург, ул Монтажников, 23, 1 этаж, офис П14</span
          >
        </div>
        <div class="group">
          <span class="item-group main">Телефон:</span>
          <div class="group-phone">
            <a href="tel: +73532307717" class="item-group"
              >+7 (3532) 30-77-17
            </a>
            <a href="tel: +79325544404" class="item-group">+7-932-554-44-04</a>
          </div>
        </div>
        <div class="group">
          <span class="item-group main">E-mail:</span>
          <span class="item-group">oren-service@yandex.ru</span>
        </div>
        <div class="group">
          <span class="item-group main">Время работы:</span>
          <span class="item-group">пн-пт с 9:00 до 18:00</span>
        </div>
        <div class="group">
          <span class="item-group main">Сайт:</span>
          <span class="item-group"
            ><a href="https://чистыйсервис.online/">чистыйсервис.online</a>
          </span>
        </div>
      </div>
      <div class="wrap-map">
        <AppMap />
      </div>
    </div>
  </div>
  <div class="wrapper">
      <h1>Поломоечные машины в Оренбурге: продажа, аренда и сервис</h1>
    <div class="wrap">
      <div class="info">
            <section id="floor-scrubbers-content" class="article">

  <p>Надежная профессиональная уборка начинается с правильного оборудования. Для торговых залов, производственных площадок, складов, медицинских учреждений и офисов ключевым помощником давно стала поломоечная техника. Наша компания специализируется на поставках и сопровождении <strong>машин для мытья полов</strong> в Оренбурге и области: от подбора модели под ваши задачи до обучения персонала, регулярного сервиса и оперативной поставки расходников.</p>

  <h2>Зачем бизнесу поломоечная машина</h2>
  <p>Современная <strong>поломоечная машина</strong> в несколько раз ускоряет цикл уборки, снижает расход воды и химии, а главное — обеспечивает стабильно высокий уровень чистоты и гигиены. Встроенные щетки и вакуумная система одновременно оттирают загрязнения и собирают влагу, оставляя покрытие сухим и безопасным. Итог — меньше простоев, меньше претензий со стороны клиентов и контролирующих органов, меньше износ покрытия.</p>
  <p>Если вам нужна компактная <strong>машина для мытья полов</strong> для узких коридоров, или наоборот — производительная самоходная машина для ангара и гипермаркета, мы подберем оптимальную конфигурацию под площадь, тип покрытия и интенсивность эксплуатации.</p>

  <h2>Когда выбрать аккумуляторную поломоечную машину</h2>
  <p>Для помещений со сложной планировкой и активным трафиком идеальна <strong>аккумуляторная поломоечная машина</strong>. Она свободна от кабелей, работает тише и безопаснее, легко маневрирует между стеллажами и стойками. Мы предлагаем решения на литий-ионных и свинцово-кислотных батареях с рассчитанным временем автономной работы. По вашему запросу рассчитаем график подзарядки, подберем зарядные станции и запасные батареи, чтобы техника отрабатывала смену без простоев.</p>
  <p>Если ваша задача — <strong>купить поломоечную машину на аккумуляторе</strong>, мы подскажем, какая ширина щеточного узла, емкость баков и давление на щетку обеспечат нужную производительность именно на ваших покрытиях — от керамогранита до промышленных эпоксидных полов.</p>

  <h2>Купить машину для мытья полов: как выбрать</h2>
  <p>Перед тем как <strong>купить машину для мытья полов</strong>, важно оценить несколько факторов:</p>
  <ul>
    <li>площадь и конфигурация объекта (длины проходов, наличие пандусов, лифтов);</li>
    <li>тип и состояние покрытия (швы, пористость, устаревшие защитные слои);</li>
    <li>характер загрязнений (пылевая нагрузка, масляные и белковые пятна, следы от тележек);</li>
    <li>график уборки (дневные часы, ночные смены, санитарные окна);</li>
    <li>требования к уровню шума и безопасности.</li>
  </ul>
  <p>Мы предложим разные форм-факторы — от ручных и задвижных до самоходных и райдеров. Варианты насадок и падов подстраиваем под ваши задачи: интенсивное удаление въевшейся грязи, поддерживающая уборка, полировка.</p>

  <h2>Поломоечные машины в Оренбурге: склад и доставка</h2>
  <p>Мы работаем по принципу «близко к клиенту»: поддерживаем склад ходовых моделей и расходников, организуем быструю доставку по городу и области, предоставляем подменный фонд. Если вы вводите новый объект в эксплуатацию и сроки «горят», предложим старт с арендной единицы с последующим выкупом: так вы сразу закрываете потребность в чистоте и параллельно тестируете модель в боевых условиях.</p>
  <p>Частый запрос — «<strong>поломоечные машины в Оренбурге</strong>» и «<strong>поломоечные машины Оренбург</strong>». По этим направлениям мы предлагаем комплекс: подбор модели, демонстрация, поставка, ввод в эксплуатацию, обучение персонала и регламентный сервис у вас на объекте.</p>

  <h2>Поломоечная машина: цена и экономика владения</h2>
  <p>Для ответственного выбора важно понимать не только первоначальную стоимость, но и полную стоимость владения (TCO). На итоговую экономику влияет ресурс щеток и падов, расход химии, стоимость батарей и их цикл жизни, затраты на сервис, время простоев. Мы откровенно сравниваем альтернативы и всегда показываем, какая <strong>поломоечная машина цена</strong> окажется оптимальной при вашем графике и типе загрязнений. Часто чуть более дорогая модель экономит десятки часов уборки в месяц и окупается быстрее.</p>
  <p>Если ваша цель «<strong>поломоечная машина купить</strong>», мы подготовим несколько конфигураций в разных бюджетах, покажем разницу в производительности по формуле м²/час и рассчитаем срок окупаемости с учетом текущей ставки аренды персонала и стоимости химии.</p>

  <h2>Аренда поломоечных машин: гибкость без капитальных затрат</h2>
  <p>Когда уборка носит сезонный характер, а площадь большая, оптимальным решением становится <strong>аренда поломоечных машин</strong>. Это позволяет обеспечить требуемый уровень чистоты без крупных единовременных инвестиций. Мы предоставляем посуточную, помесячную и долгосрочную аренду с полным сервисом: доставка на объект, инструктаж, плановое обслуживание, замена расходников. По запросу включаем химию и пэды в пакет, а также предлагаем вариант «аренда с выкупом», чтобы постепенно перейти к собственному парку.</p>

  <h2>Ремонт и сервис: чтобы техника работала без сбоев</h2>
  <p>Даже самая надежная техника требует внимания. Мы выполняем <strong>ремонт поломоечных машин</strong> любой сложности: диагностика электроники, восстановление вакуумных турбин, сервис щеточных узлов, обслуживание редукторов, восстановление герметичности баков, замена уплотнений, ремонт помп подачи воды и дозаторов химии, регулировка прижимов сквиджа, восстановление кабельных жгутов. Для аккумуляторных решений проводим проверку емкости, балансировку и своевременную замену батарей, чтобы сохранить автономность и производительность на заданном уровне, снизить риск внеплановых простоев и продлить срок службы техники.</p>

  <h2>«Купить поломоечную машину Оренбург»: что получает клиент</h2>
  <ol>
    <li><strong>Аудит объекта</strong> — выезжаем, оцениваем площадь, покрытие, интенсивность движения.</li>
    <li><strong>Подбор и демонстрация</strong> — даем протестировать технику в реальных условиях.</li>
    <li><strong>Поставка и ввод</strong> — привозим, настраиваем, обучаем персонал, фиксируем регламенты.</li>
    <li><strong>Сервис и расходники</strong> — ведем оборудование, напоминаем о ТО, держим склад щеток, падов, резин.</li>
    <li><strong>Подменный фонд</strong> — в редких случаях поломки оперативно заменяем на рабочую единицу.</li>
  </ol>

  <h2>Безопасность и требования к гигиене</h2>
  <p>Мы подбираем сертифицированные чистящие средства под конкретные покрытия и отраслевые требования. Для пищевых производств и торговых залов предлагаем низкопенные составы, совместимые с вакуумными системами. Для медицинских учреждений — решения с антисептическим эффектом. Наши специалисты обучают персонал корректной дозировке, уходу за щетками, своевременной промывке баков и фильтров — это напрямую влияет на ресурс техники и качество уборки.</p>

  <h2>Дополнительные услуги и обучение</h2>
  <p>Помимо поставки мы берем на себя внедрение технологий уборки на объекте: составляем маршрутные карты, рассчитываем норму времени, подбираем пэды и режимы давления, настраиваем дозирование химии, обучаем операторов безопасной работе. При необходимости интегрируем технику в систему клининга по KPI и предоставляем отчеты по работам. Для сетевых клиентов готовим единые стандарты и регламенты, чтобы во всех филиалах «пол стоял идеально».</p>

  <h2>Как оформить заказ</h2>
  <p>Свяжитесь с нами и расскажите, где и как будет работать техника. Сориентируем по срокам, бюджету, подберем «короткий список» моделей, согласуем демонстрацию и выезд инженера. Нужна <strong>машина для мытья полов</strong> «здесь и сейчас»? Предложим ближайшую доступную на складе конфигурацию, а если требуется, запустим объект с арендной единицей. Хотите узнать актуальные предложения по запросу «<strong>поломоечная машина цена</strong>»? Подготовим коммерческое предложение в нескольких вариантах и наглядно сравним экономики.</p>

  <h2>Итог</h2>
  <p>Нужна надежная <strong>поломоечная машина</strong> под вашу задачу — от компактной ручной до производительного райдера? Планируете <strong>поломоечные машины в Оренбурге</strong> для сети магазинов, склада, автосалона или медицинского центра? Хотите <strong>поломоечные машины Оренбург</strong> с быстрым запуском и гарантированным сервисом? Мы поможем определиться, провести демонстрацию на объекте, организовать поставку, <strong>аренда поломоечных машин</strong> доступна на гибких условиях, а <strong>ремонт поломоечных машин</strong> выполняется оперативно и с гарантией качества. Свяжитесь с нами, чтобы получить консультацию и коммерческое предложение — поможем подобрать решение под ваши задачи и бюджет.</p>
</section>

      </div>
    </div>
  </div>
</template>
<style scoped>
.wrapper {
  width: 100%;
  padding: 10px 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

h1 {
  color: #fff;
  font-size: 50px;
  line-height: 57px;
  width: fit-content;
  padding-bottom: 10px;
  border-bottom: 3px solid #feb803;
}

.wrap {
  width: 100%;
  display: flex;
  align-items: stretch;
  gap: 20px;
}

.group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.info {
  background: linear-gradient(90deg, #feb803 0%, #ff9a06 100%);
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  gap: 15px;
  border-radius: 15px;
}

.info,
.wrap-map {
  flex: 50%;
}

.wrap-map {
  overflow: hidden;
  height: 43vh;
  border-radius: 15px;
}

.item-group,
.item-group a {
  font-size: 25px;
  line-height: 28px;
  font-weight: 400;
  color: #fff;
}

.main {
  font-weight: 700;
}

.item-group::after {
  margin-top: 2px;
  background-color: #fff; /* Цвет линии при наведении на нее курсора мыши */
  display: block;
  content: "";
  height: 2px; /* Высота линии */
  width: 0%;
  -webkit-transition: width 0.3s ease-in-out;
  -moz--transition: width 0.3s ease-in-out;
  transition: width 0.3s ease-in-out;
}
.item-group:hover:after,
.item-group:focus:after {
  width: 100%;
}

.group-phone {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

@media (max-width: 1200px) {
  .info {
    gap: 10px;
    padding: 15px;
  }

  .item-group,
  .item-group a {
    font-size: 20px;
    line-height: 20px;
  }
}

@media (max-width: 930px) {
  .wrapper {
    padding: 20px 10px;
  }
}

@media (max-width: 850px) {
  .wrap {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .item-group,
  .item-group a {
    font-size: 16px;
    line-height: 16px;
  }

  .info {
    gap: 8px;
  }
}
</style>
